interface Props {
	label: React.ReactNode;
	unit?: string;
	headerLabelClass?: string;
	headerLabelUnitClass?: string;
}

export const ColumnHeaderLabel = ({ label, unit, headerLabelClass = "", headerLabelUnitClass = "" }: Props) => (
	<div className={`flex  items-center justify-center leading-tight gap-1`}>
		<div className={`font-light text-sm text-stone-950 ${headerLabelClass}`}>{label}</div>
		{unit && <div className={`text-[0.6rem] text-stone-400  ${headerLabelUnitClass}`}>[{unit}]</div>}
	</div>
);
